import api from '../../../api/client'

function normalizeArrayPayload(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.items)) return data.items
  return []
}

export async function fetchReportModules() {
  const { data } = await api.get('/reports/modules')
  return normalizeArrayPayload(data?.modules)
}

export async function fetchPredefinedReports(moduleId, submodule = null) {
  const params = { module: moduleId }
  if (submodule) {
    params.submodule = submodule
  }
  const { data } = await api.get('/reports/predefined', { params })
  return normalizeArrayPayload(data?.reports)
}

export async function runPredefinedReport(payload) {
  const { data } = await api.post('/reports/run', payload)
  return data || {}
}

export async function exportPredefinedReport(payload) {
  const response = await api.post('/reports/export', payload, {
    responseType: 'blob',
  })
  const contentDisposition = response.headers?.['content-disposition'] || ''
  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i)
  const filename = filenameMatch?.[1] || 'report-export.xls'
  return { blob: response.data, filename }
}

export async function fetchReportPreferences(moduleId, reportKey) {
  const { data } = await api.get('/reports/preferences', {
    params: {
      module: moduleId,
      reportKey,
    },
  })
  return data || {}
}

export async function saveReportPreferences(payload) {
  const { data } = await api.put('/reports/preferences', payload)
  return data || {}
}

export async function fetchCompanyOptions(params = {}) {
  const { data } = await api.get('/options/companies', { params })
  return normalizeArrayPayload(data)
}

export async function fetchBranchOptions(params = {}) {
  const { data } = await api.get('/options/branches', { params })
  return normalizeArrayPayload(data)
}

export async function fetchDepartmentOptions(params = {}) {
  const { data } = await api.get('/options/departments', { params })
  return normalizeArrayPayload(data)
}

export async function fetchUserOptions(params = {}) {
  const { data } = await api.get('/options/users', { params })
  return normalizeArrayPayload(data)
}

export async function fetchProjectOptions(params = {}) {
  const { data } = await api.get('/options/projects', { params })
  return normalizeArrayPayload(data)
}

export async function fetchUpcomingReportSchedules(params = {}) {
  const { data } = await api.get('/reports/schedules/upcoming', { params })
  return normalizeArrayPayload(data?.items)
}

export async function fetchReportScheduleOptions() {
  const { data } = await api.get('/reports/schedules/options')
  return data || {}
}

export async function listReportSchedules(params = {}) {
  const { data } = await api.get('/reports/schedules', { params })
  return data || {}
}

export async function fetchReportScheduleById(scheduleId) {
  const { data } = await api.get(`/reports/schedules/${scheduleId}`)
  return data || {}
}

export async function createReportSchedule(payload) {
  const { data } = await api.post('/reports/schedules', payload)
  return data || {}
}

export async function updateReportSchedule(scheduleId, payload) {
  const { data } = await api.patch(`/reports/schedules/${scheduleId}`, payload)
  return data || {}
}

export async function updateReportScheduleStatus(scheduleId, action) {
  const { data } = await api.patch(`/reports/schedules/${scheduleId}/status`, { action })
  return data || {}
}
